/**
 * List Schema of PontaSla
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {PontaSla} from '@/model/resource/PontaSla'

/* TODO: review generated schema */
export class ListPontaSlaSchema extends Schema {
  readonly name = 'ListPontaSla'

  readonly fieldSet: FieldSet<PontaSla> = {
    idPontaSlaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    abreviacao: (): FieldComponent => ({
      is: Component.Render,
    }),
    uf: (): FieldComponent => ({
      is: Component.Render,
    }),
    naCapital: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.naCapital),
      },
    }),
    cidade: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
